import Intro from './components/Intro.jsx';
import ComingMatches from './components/ComingMatches.jsx';
import PastMatches from './components/PastMatches.jsx';
import Footer from './components/Footer.jsx';
import './styles/App.css';
import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

// App function launches when the form is accessed

function App() {
  
  const [matchData, setMatchData] = useState([]);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    
    if (!hash) {
        console.warn('No hash found in the URL');
        setLoading(false);
        return;
      } else {
        fetch(`/api/tickets/hash/${hash}`)
          .then(response => {
                if (!response.ok) {
                  throw new Error('Failed to fetch tickets data');
                }
                return response.json();
              })
          .then(data => {
                  setMatchData(data);
                  setLoading(false);
                })
          .catch(error => {
                  console.error('Error fetching tickets:', error);
                  setLoading(false);
                });
      }
  }, []);

  return (
    <div className="App">
      <ToastContainer
              position="top-right"
              autoClose={3000}
              limit={3}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick={false}
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
      />
      <Intro />
      <ComingMatches matches={matchData} setMatchData={setMatchData} loading={loading} />
      <PastMatches matches={matchData} setMatchData={setMatchData} loading={loading} />
      <Footer />
    </div>
  );
}

export default App;
